exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divider[data-v-66f2e33c]{align-self:stretch;border:1px solid var(--color-neutral-gray-lighter);height:auto;width:auto\n}", ""]);

// exports
